import React from "react";
import MDButton from "materialDashboard/components/MDButton";
import {CircularProgress} from "@mui/material";
import MDBox from "materialDashboard/components/MDBox";

const MDLoadingButton = ({disabled, loading, children, ...rest}) => {

    return <MDButton {...rest} disabled={disabled || loading} position="relative">
        {loading && <MDBox position="absolute" sx={{inset: 0, display: "flex", alignItems: "center", justifyContent: "center"}}>
            <CircularProgress size={16} color="inherit"/>
        </MDBox>}
        {children}
    </MDButton>
}

export default MDLoadingButton;